module.exports = __webpack_public_path__ + "img/fb.15e17b9c.svg";